<template>
  <v-container v-if="worldSelected">
    <div class="text-center background text border pt-2 pb-2">
      <v-row>
        <v-col
          v-for="category in categories"
          :key="category.id"
          class="col-4 col-md-3"
        >
          <div
            v-if="category == categorySelected"
            @click="categorieSelected(category)"
            class="border mr-3 ml-3 hoverable"
            :class="selected"
          >
            {{ category }}
          </div>
          <div
            v-else
            @click="categorieSelected(category)"
            class="border mr-3 ml-3 hoverable"
          >
            {{ category }}
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>


<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      selected: "bg-secondary",
    };
  },
  methods: {
    ...mapMutations(["selectCategorie","getCategoryPrices"]),
    categorieSelected(category) {

      this.selectCategorie(category);
      this.getCategoryPrices({
        world: this.worldSelected,
        category: category
      });
    },
  },
  computed: {
    ...mapState(["categories", "categorySelected", "worldSelected"]),
  },
};
</script>

<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147);
}

.border {
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
}
.hoverable:hover {
  cursor: pointer;
  background-color: rgb(60, 60, 60);
}
</style>